// extracted by mini-css-extract-plugin
export default {"header-view":"index_header-view__77MGA"};